var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mr4sy5j0ma"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.976471 0 0 0 0 0.725490 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#mr4sy5j0ma)",
    transform: "translate(-643 -609)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M38.03 36.516c.328.763-.022 1.648-.784 1.978-.763.33-1.648-.021-1.978-.783-1.452-3.354-4.88-5.523-8.736-5.523-3.946 0-7.396 2.166-8.787 5.52-.241.577-.8.927-1.39.928-.193 0-.388-.037-.577-.116-.767-.319-1.13-1.2-.811-1.966 1.86-4.48 6.4-7.373 11.566-7.373 5.056 0 9.57 2.879 11.496 7.335zm-23.762-18.22c-.339-.59-.135-1.342.454-1.68l4.536-2.606c.59-.338 1.342-.135 1.681.454.34.59.136 1.342-.454 1.68l-4.536 2.605c-.59.34-1.343.136-1.681-.453zm23.671 0c.34-.59.136-1.342-.454-1.68l-4.536-2.606c-.59-.338-1.342-.135-1.681.454-.339.59-.135 1.342.454 1.68l4.536 2.605c.59.34 1.343.136 1.681-.453zm-16.633.053c.847.847.847 2.22 0 3.066-.846.847-2.22.847-3.067 0s-.847-2.22 0-3.066c.847-.847 2.22-.847 3.067 0zm12.935-.036c.846.847.846 2.22 0 3.066-.848.847-2.222.847-3.068 0-.846-.845-.846-2.219 0-3.066.847-.847 2.22-.847 3.068 0zM42.859 52H9.142C4.102 52 0 47.9 0 42.858V9.142C0 4.1 4.102 0 9.142 0h33.717C47.899 0 52 4.101 52 9.142v33.716C52.001 47.9 47.9 52 42.859 52zM4.302 9.141v33.716c0 2.669 2.171 4.84 4.84 4.84h33.717c2.668 0 4.84-2.171 4.84-4.84V9.142c0-2.669-2.172-4.84-4.84-4.84H9.142c-2.669 0-4.84 2.17-4.84 4.84z",
    transform: "translate(643 609)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress);
export default __webpack_public_path__ + "static/media/stress.ecd2a46cf30a35d74f93e3e940917f1e.svg";
export { ForwardRef as ReactComponent };